module.exports = __webpack_public_path__ + "assets/img/living_5-2.7d283fa3.jpg";